
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { interimOrderSurveyDataInfoType, nextAppearanceSurveyDataInfoType, partyInformationRQSSurveyDataInfoType, requestForSchedulingDataInfoType } from '@/types/Application/RequestScheduling';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})

export default class Form39Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;  

    existingFileNumber = '';
   
    yourInfo = {} as yourInformationInfoDataInfoType;  
    otherParties = ''; 
    acknowledgeService = false;

    filedDate = '';
    lastAppearanceDate = '';
    reviewOrderMade = false;

    reasons = [];
    flmTypes = [];
    descriptionOnChange = '';
    reasonForChange = '';

    appearanceType = '';
    otherAppearanceDesc = '';
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){ 
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);       
        this.getRequestSchedulingInfo();    
        this.getReasonForSchedulingInfo(); 
        this.getNextAppearanceInfo(); 
        this.getPartyInfo();        
    } 

    public getRequestSchedulingInfo(){      
        
        this.filedDate = '';
        this.lastAppearanceDate = '';
        this.reviewOrderMade = false;

        if(this.result?.requestForSchedulingSurvey){

            let requestForScheduling = {} as requestForSchedulingDataInfoType;

            requestForScheduling = this.result.requestForSchedulingSurvey;

            if (requestForScheduling.Unresolved == 'n' && requestForScheduling.ReviewOrdered == 'y'){
                this.reviewOrderMade = true;
            }

            this.filedDate = requestForScheduling.FiledDate?requestForScheduling.FiledDate:'';
            this.lastAppearanceDate = requestForScheduling.LastAppearanceDate?requestForScheduling.LastAppearanceDate:'';           
        }             
    }

    public getPartyInfo(){  
        
        this.yourInfo = {} as yourInformationInfoDataInfoType;
        this.otherParties = '';

        if(this.result?.partyInformationRQSSurvey){

            let partyInfo = {} as partyInformationRQSSurveyDataInfoType;

            partyInfo = this.result.partyInformationRQSSurvey;
            this.yourInfo = getYourInformationResults(partyInfo);

            const otherPartiesList = [];
            for (const otherParty of partyInfo.otherPartyInfoRqs){
                otherPartiesList.push(Vue.filter('getFullName')(otherParty.name))
            }
            this.otherParties = otherPartiesList.join(', ');   
            
            this.acknowledgeService = this.result.otherPartyRQSConfirmationSurvey?.confirmation == 'Confirmed';
        
        }
    
    }

    public getNextAppearanceInfo(){

        this.appearanceType = '';
        this.otherAppearanceDesc = '';

        if(this.result?.nextAppearanceSurvey){

            let appearanceInfo = {} as nextAppearanceSurveyDataInfoType;
            appearanceInfo = this.result.nextAppearanceSurvey;
            this.appearanceType = appearanceInfo.AppearanceType?appearanceInfo.AppearanceType:'';

            if (this.appearanceType == 'other'){
                this.otherAppearanceDesc = appearanceInfo.AppearanceTypeComment?appearanceInfo.AppearanceTypeComment:'';
            }
        }
    }    

    public getReasonForSchedulingInfo(){       

        this.reasons = [];
        this.flmTypes = [];
        this.descriptionOnChange = '';
        this.reasonForChange = '';        
        
        if(this.result?.reasonForSchedulingSurvey){

            this.reasons = this.result.reasonForSchedulingSurvey;  

            if (this.reasons.includes('family') || this.reasons.includes('orderChanged')){

                if(this.result?.interimOrderSurvey){

                    let interimInfo = {} as interimOrderSurveyDataInfoType;
                    interimInfo = this.result.interimOrderSurvey;

                    if (interimInfo.family){
                        this.flmTypes = interimInfo.FlmType?interimInfo.FlmType:[];
                    }

                    if (interimInfo.orderChanged){
                        this.descriptionOnChange = interimInfo.DescriptionOnChange?interimInfo.DescriptionOnChange:'';
                        this.reasonForChange = interimInfo.ReasonForChange?interimInfo.ReasonForChange:'';
                    }
                }
            }
        
        }        
    
    }    
 
}
